import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Markdown from "markdown-to-jsx";
import fm from "front-matter";
import Layout2 from "../components/Layout/Layout2";

function WorkDetails2(props) {
  const [meta, setMeta] = useState("");
  const [content, setContent] = useState("");
  const title = props.match.params.title.replace(/-/g, "");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    import(`../works/${title}.md`)
      .then((res) => res.default)
      .then((res) => {
        fetch(res)
          .then((data) => data.text())
          .then((res) => {
            let result = fm(res);
            setMeta(result.attributes);
            setContent(result.body);
          });
      })
      .catch((err) => {
        throw new Error(err);
      });
  }, [title]);

  return (
    <Layout2>
      <section className="shadow-blue white-bg padding mt-0">
        <Link to="/works" className="btn btn-default work-details-back">
          <i className="icon-arrow-left" aria-hidden="true"></i> Back to Portfolio
        </Link>
        <ul className="list-inline portfolio-info mt-0">
          <li className="list-inline-item">
            {meta.author}
          </li>
          <li className="list-inline-item">
            {meta.date}
          </li>
          <li className="list-inline-item">
            <a
              href={meta && meta.link}
              target="__blank"
              rel="noopener noreferrer"
            >
              {meta && meta.link}
            </a>
          </li>
        </ul>
        <div className="work-details-content">
          <Markdown options={{ forceBlock: true }} children={content}></Markdown>
        </div>
      </section>
    </Layout2>
  );
}

export default WorkDetails2;
